import type { SocialPostSceneBlockV1 } from "@runcheetah/shared";

import type { CreativeLayerEntry } from "./campaign-creative-layer-ordering";

export function getLayerMetaLabel({
  entry,
  isTransformActive,
}: {
  entry: CreativeLayerEntry;
  isTransformActive: boolean;
}) {
  const typeLabel = getLayerTypeLabel(entry.block);

  if (isTransformActive) {
    return `${typeLabel} · Editing bounds`;
  }

  return typeLabel;
}

export function getLayerTypeLabel(block: SocialPostSceneBlockV1) {
  switch (block.type) {
    case "text":
      return "Text";
    case "image":
      return "Image";
    case "logo":
      return "Logo";
    case "rect":
      return "Shape";
    case "frame":
      return "Frame";
    case "shape":
      return "Shape";
    default:
      return "Layer";
  }
}
